import { render, staticRenderFns } from "./galeria.vue?vue&type=template&id=267761ce&scoped=true"
import script from "./galeria.vue?vue&type=script&lang=js"
export * from "./galeria.vue?vue&type=script&lang=js"
import style0 from "./galeria.vue?vue&type=style&index=0&id=267761ce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "267761ce",
  null
  
)

export default component.exports